import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles((theme) => ({
  dialog: {
    minWidth: 400,
  },
  content: {
    padding: theme.spacing(3),
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#ff9800",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  message: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  warningBox: {
    backgroundColor: "#fff3cd",
    color: "#856404",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    border: `2px solid #ffc107`,
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  warningIcon: {
    fontSize: "2rem",
    color: "#ff9800",
  },
  connectionInfo: {
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  actions: {
    padding: theme.spacing(2),
    justifyContent: "center",
  },
  cancelButton: {
    marginLeft: theme.spacing(1),
  },
}));

const ConnectionWarningModal = ({
  open,
  onClose,
  connectionName,
  connectionStatus
}) => {
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle className={classes.title}>
        <WarningIcon className={classes.warningIcon} />
        Conexión Desconectada
      </DialogTitle>

      <DialogContent className={classes.content}>
        <Box className={classes.warningBox}>
          <WarningIcon style={{ fontSize: "1.5rem", marginTop: "4px", color: "#ff9800" }} />
          <Box style={{ flex: 1 }}>
            <Typography variant="body1" style={{ fontWeight: "bold", marginBottom: "8px" }}>
              La conexión <strong style={{ color: "#856404" }}>"{connectionName}"</strong> está <strong style={{ color: "#856404" }}>{connectionStatus}</strong>.
            </Typography>
            <Typography variant="body2" style={{ marginBottom: "8px" }}>
              No se puede transferir el ticket a una conexión desconectada.
            </Typography>
            <Typography variant="body2" style={{ marginTop: "8px", color: "#856404", fontWeight: "bold" }}>
              Por favor, seleccione una conexión <strong>CONNECTED</strong> o espere a que se reconecte.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          className={classes.cancelButton}
        >
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConnectionWarningModal;
